import type { CSSProperties } from 'react';

const fontStack = {
  display: 'IvyPresto Display',
  sans: 'Gotham',
} as const;

const sizes = {
  '64': {
    fontSize: 'var(--font-size-64, 64px)',
    lineHeight: 'normal',
    letterSpacing: '-0.02em',
  },
  '48': { fontSize: 'var(--font-size-48, 48px)', lineHeight: 'normal' },
  '40': { fontSize: 'var(--font-size-40, 40px)', lineHeight: 'normal' },
  '36': { fontSize: 'var(--font-size-36, 36px)', lineHeight: 'normal' },
  '30': { fontSize: 'var(--font-size-30, 30px)', lineHeight: '36.3px' },
  '24': { fontSize: 'var(--font-size-24, 24px)', lineHeight: 'normal' },
  '20': { fontSize: 'var(--font-size-20, 20px)', lineHeight: 'normal' },
  '18': { fontSize: 'var(--font-size-18, 18px)', lineHeight: 'normal' },
  '16': { fontSize: 'var(--font-size-16, 16px)', lineHeight: 'normal' },
  '14': { fontSize: 'var(--font-size-14, 14px)', lineHeight: 'normal' },
  '12': { fontSize: 'var(--font-size-12, 12px)', lineHeight: 'normal' },
  '10': { fontSize: 'var(--font-size-10, 10px)', lineHeight: 'normal' },
} as const;

const baseStyle: CSSProperties = {
  fontStyle: 'normal',
  display: 'inline-block',
};

function style(
  fontFamily: string,
  sizeKey: keyof typeof sizes,
  fontWeight: number,
  overrides: Partial<CSSProperties> = {}
): CSSProperties {
  return {
    ...baseStyle,
    fontFamily,
    ...sizes[sizeKey],
    fontWeight,
    ...overrides,
  };
}

export const display = style(fontStack.display, '64', 400);
export const sectionHeading = style(fontStack.display, '48', 400);
export const large = style(fontStack.display, '40', 400);
export const heading1 = style(fontStack.display, '36', 400);
export const heading2 = style(fontStack.display, '30', 400);
export const heading3 = style(fontStack.display, '24', 400);
export const heading4 = style(fontStack.sans, '20', 400);
export const heading5 = style(fontStack.sans, '18', 300);
export const bodyText = style(fontStack.sans, '16', 325);
export const bodyTextBold = style(fontStack.sans, '16', 350);
export const buttonText = style(fontStack.sans, '14', 325, {
  textTransform: 'uppercase',
});
export const bodySmall = style(fontStack.sans, '14', 325);
export const caption = style(fontStack.sans, '12', 325);
export const tabLabel = style(fontStack.sans, '10', 325);

export const typography = {
  display,
  sectionHeading,
  large,
  heading1,
  heading2,
  heading3,
  heading4,
  heading5,
  bodyText,
  bodyTextBold,
  buttonText,
  bodySmall,
  caption,
  tabLabel,
} as const;

export type TypographyVariant = keyof typeof typography;
